import { z } from 'zod'

export const schema = z.object({
  hasError: z.boolean(),
})

export type schemaType = z.infer<typeof schema>

export const paramsSchema = z.object({
  cottageUid: z.string(),
})

export type paramsType = z.infer<typeof paramsSchema>

export type returnType = ApiServerResponse<schemaType>
